import React from "react";

export default function HowItWorksSection() {
  const steps = [
    {
      id: 1,
      title: "Diagnóstico estratégico",
      description: "Entendemos o perfil da sua marca, objetivos ESG e oportunidades de conexão com causas.",
    },
    {
      id: 2,
      title: "Co-criação da solução",
      description: "Desenhamos o formato ideal: Produto Solidário, Experiência de Impacto ou Projeto Incentivado.",
    },
    {
      id: 3,
      title: "Ativação com tecnologia e curadoria",
      description: "Implementamos a ação com suporte completo: tech, operação e governança social.",
    },
    {
      id: 4,
      title: "Comunicação e relatórios",
      description: "Entregamos conteúdo de impacto, relatórios e certificados para marca, clientes e investidores.",
    }
  ];

  return (
    <section className="bg-[#002342] pl-4 sm:pl-6 md:pl-8 lg:pl-12 xl:pl-[199px] py-12 md:py-16 lg:py-20 xl:py-[80px] overflow-hidden">
      <div className="relative">

        {/* Main Layout: 2 Columns on Desktop */}
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-8 lg:gap-12 xl:gap-[60px] items-start">

          {/* Left Column: Title + Steps */}
          <div className="order-2 lg:order-1">
            {/* Title */}
            <div className="mb-8 md:mb-12 lg:mb-16 xl:mb-[60px]">
              <h2 className="font-bauhaus font-bold text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-[42px] leading-tight lg:leading-[50px] xl:leading-[46px] text-white lg:text-left text-center">
                Como sua empresa{" "}
                <span className="text-[#5DBA3B]">ativa impacto</span>{" "}
                com a magikk
              </h2>
            </div>

            {/* Steps Grid 2x2 */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 md:gap-8 lg:gap-10 xl:gap-[32px]">
              {steps.map((step) => (
                <div key={step.id} className="flex flex-col gap-3 md:gap-4 lg:gap-5 xl:gap-[16px] group">
                  {/* Step Number Circle */}
                  <div className={`w-[40px] h-[40px] sm:w-[45px] sm:h-[45px] md:w-[50px] md:h-[50px] lg:w-[55px] lg:h-[55px] xl:w-[48px] xl:h-[48px] rounded-[20px] sm:rounded-[25px] md:rounded-[30px] lg:rounded-[35px] xl:rounded-[40px] flex items-center justify-center flex-shrink-0 transition-all duration-300 bg-white shadow-lg`}>
                    <span className={`font-raleway font-bold text-[24px] sm:text-[28px] md:text-[32px] lg:text-[34px] xl:text-[36px] transition-colors text-[#5DBA3B]`}>
                      {step.id}
                    </span>
                  </div>

                  {/* Step Content */}
                  <div className="flex-1">
                    <h3 className="font-raleway font-bold text-[14px] sm:text-[16px] md:text-[18px] lg:text-[19px] xl:text-[20px] text-[#5DBA3B] mb-2 md:mb-[8px] transition-colors">
                      {step.title}
                    </h3>
                    <p className="font-raleway font-medium text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] xl:text-[14px] text-white leading-relaxed">
                      {step.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Team Photo */}
          <div className="order-1 lg:order-2">
            <div className="relative w-full">
              <div className="w-full h-[300px] sm:h-[350px] md:h-[400px] lg:h-[450px] xl:h-[417px] rounded-l-[25px] sm:rounded-l-[30px] md:rounded-l-[40px] lg:rounded-l-[45px] xl:rounded-l-[50px] overflow-hidden">
                <img
                  src="/assets/landing-2025/team-photo.png"
                  alt="Equipe Magikk"
                  className="w-full h-full object-cover"
                />
              </div>

            </div>

            {/* Bottom Text with Green Line - Below the image */}
            <div className="mt-6 md:mt-8 lg:mt-10 xl:mt-[40px]">
              <div className="flex items-start gap-3 sm:gap-4 md:gap-5 lg:gap-6 xl:gap-[16px] max-w-[600px] lg:max-w-[500px] xl:max-w-[467px]">
                <div className="w-[4px] sm:w-[5px] md:w-[6px] lg:w-[7px] xl:w-[9px] h-[40px] sm:h-[45px] md:h-[50px] lg:h-[55px] xl:h-[61px] bg-[#5DBA3B] rounded-full flex-shrink-0 mt-1"></div>
                <p className="font-raleway font-medium text-[12px] sm:text-[13px] md:text-[14px] lg:text-[15px] xl:text-[14px] text-white leading-relaxed">
                  De pequenos até grandes negócios, da startup ao projeto social, de investidores a doadores, conectamos marcas, pessoas e causas com impacto rastreável e posicionamento com responsabilidade ambiental.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
